import { getTariffByClass, ValidationError } from '../../..';
import { getPaymentByID } from '../async/payments/selectors';
import { get, set } from '../utils';
import * as paths from './paths';
import { getRequirementDeps } from './requirements/selectors';
import { getDraftTariff } from './tariff/selectors';
var requirementValidator = {
    boolean: function isNotTrue(_, value) {
        return value !== true;
    },
    number: function isNotNumber(_, value) {
        return typeof value !== 'number';
    },
    select: function isNotSelect(requirement, value) {
        if (value === undefined) {
            return true;
        }
        // нужно обязательно проверить что значение выбрано из опшинов
        if (requirement.select) {
            return !requirement.select.options.some(function (o) { return o.value === value; });
        }
        return false;
    },
    string: function isNotString(_, value) {
        return typeof value !== 'string';
    },
};
var stubFalse = function () { return false; };
// валидатор пока очень корявый, в плане кода, потом разобью на функции
// todo сделать человеческий валидатор
var defaultValidators = [
    [
        paths.requirements([]),
        function validateRequirements(errors, _, state) {
            var requirementDeps = getRequirementDeps(state);
            var draftTariff = getDraftTariff(state);
            var maxTariffs = get(state.async, ['zoneInfo', 'data', 'max_tariffs']) || [];
            var maxTariff = maxTariffs.find(function (t) { return t.class === draftTariff; });
            if (maxTariff) {
                // валидатор обязательных требований
                return (maxTariff.supported_requirements || []).reduce(function (acc, requirement) {
                    if (requirement.glued) {
                        var requirementPath = paths.requirementValue(requirementDeps, requirement.name);
                        var draftRequirement = get(state.draft.values, requirementPath);
                        var isNotValidValue = requirementValidator[requirement.type] || stubFalse;
                        if (isNotValidValue(requirement, draftRequirement)) {
                            return set(acc, requirementPath, ValidationError.REQUIRED);
                        }
                    }
                    return acc;
                }, errors);
            }
            return errors;
        },
    ],
    [
        paths.tariff,
        function (errors, tariff, state) {
            return !getTariffByClass(tariff, state)
                ? set(errors, paths.tariff, ValidationError.UNAVAILABLE_TARIFF)
                : errors;
        },
    ],
    [
        paths.route,
        function (errors, route) {
            var routeErrors = route.map(function (_a) {
                var address = _a.address;
                return !(address === null || address === void 0 ? void 0 : address.geoObject)
                    ? ValidationError.EMPTY_ADDRESS
                    : undefined;
            });
            return routeErrors.reduce(function (acc, error, index) {
                var currentError = get(acc, paths.routeItem(index, 'address'));
                // пишем ошибку только если пользователь не провалидировал адресс
                if (error && !currentError) {
                    return set(acc, paths.routeItem(index, 'address'), error);
                }
                return acc;
            }, errors);
        },
    ],
    [
        paths.payment,
        function (errors, payment, state) {
            if (payment === null || payment === void 0 ? void 0 : payment.id) {
                return !getPaymentByID(payment.id, state)
                    ? set(errors, paths.payment, ValidationError.UNAVAILABLE_PAYMENT)
                    : errors;
            }
            return errors;
        },
    ],
];
export var validator = function (userValidator) {
    return function (values, state) {
        var userErrors = userValidator === null || userValidator === void 0 ? void 0 : userValidator(values, state);
        return defaultValidators.reduce(function (errors, _a) {
            var path = _a[0], validator = _a[1];
            var value = get(values, path);
            return validator(errors, value, state);
        }, userErrors);
    };
};
